import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import InfoGenesis from "../../../assets/img/Featured/kiosk-retail.png";
import IGKiosk from "../../../assets/img/Featured/kiosk-checkout.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../../context/DataProvider";
import { Header } from "../../../components/Header";

const MarketPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page marketPage">
            <Header />
            <div className="page-header">Hotel</div>
            <div className="text-wrapper">
                <div className="top">
                    <div className="topic-header">Grab N Go Market</div>
                    <HorizontalLine />
                </div>
                <div className="std-text">
                    Meeting customers where they prefer is never
                    more important than in a grab n go market.
                    Customers today want many ways to shop, from
                    traditional check-out, to self-service kiosks, online
                    or walk-out options. They not only demand these
                    choices but have high expectations that the items
                    they want will be available for sale.
                </div>
            </div>

            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Hotel - Grab N Go Market", "InfoGenesis");
                    addFlow("InfoGenesis");
                    navigate("/solutions/info-genesis")}}>
                    <img src={InfoGenesis} alt="" />
                    <div className="item-head">
                        <LogoMini />
                        InfoGenesis
                    </div>
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Hotel - Grab N Go Market", "IG Kiosk");
                    addFlow("IG Kiosk");
                    navigate("/solutions/ig-kiosk")}}>
                    <img src={IGKiosk} alt="" />
                    <div className="item-head">
                        <LogoMini />
                        IG Kiosk
                    </div>
                </div>
            </FeaturedSolutions>
        </div>
    )
}

export default MarketPage;